import { AspectRatio, Box, Flex, Heading, SimpleGrid,Text} from "@chakra-ui/react"
import { graphql } from "gatsby"
import React from 'react'
import Helmet from 'react-helmet'
import { useIntl } from 'react-intl'
import { CollectionBox } from '../../components/Cards/Collection'
import { ProductItem } from '../../components/Cards/Order/Product'
import { ProductCategoriesDropDown } from "../../components/Dropdowns/ProductCategories"
import Footer from '../../components/Footer'
import { FAQ } from '../../components/Layout/FAQ'
import { HorizontalPaymentInformation } from "../../components/Layout/HorizontalPaymentInformation"
import { HowtoShopCheaperwithBriddgy } from '../../components/Layout/HowtoShopCheaperwithBriddgy'
import NavbarDefault from '../../components/Navbar'
import { BottomNavbar } from '../../components/Navbar/BottomNavbar'
import { LandingSwiper } from "../../components/Swipers/LandingProductSwiper"
import { ECOMMERCE_MESSAGES } from '../../intl/messages'
import { NavigationContext } from '../../providers/navPage'




  
const BriddgyShopPage = ({data})=>{
    const intl = useIntl()
    return (
        <>
      <Helmet title={intl.formatMessage(ECOMMERCE_MESSAGES.shops_title)} defer={false}>
        <meta
          name="description"
          content={intl.formatMessage(ECOMMERCE_MESSAGES.shops_description)}
        />
      </Helmet>
      <NavigationContext.Provider value={{ page: "shop" }}>
        <NavbarDefault />
        <BottomNavbar />
      </NavigationContext.Provider>
     
      <ProductCategoriesDropDown/>
      <Box py='80px'  w='100%'  as='header' >
        <Box maxW='container.xl' mx='auto'>
          <LandingSwiper products={data.products.nodes}/>
        </Box>
      </Box>
      <HorizontalPaymentInformation/>
      <Box bg='outline.light' py={20} as='section'>
        <Heading maxW='container.lg' mx='auto' mb={4} as='h1' fontSize="hb3" fontWeight="700" textAlign="center"  >
            {intl.formatMessage(ECOMMERCE_MESSAGES.shopproductsonline)}
        </Heading>
        <Text maxW='container.md' mx='auto' mb={10} as='h2' textAlign='center'>
        {intl.formatMessage(ECOMMERCE_MESSAGES.findinterestingproducts)}
        </Text>
        <Flex justifyContent='center'>
          <AspectRatio maxW='container.md' w='100%' mx='auto' borderRadius='base' border='1px solid' borderColor='outline.medium' h='100%' bg='white' p={0} m={0} ratio={3/2} >
              <Box as='video'  autoPlay muted controls>
                <source src="/video/Orderer Video.mp4" type="video/mp4" />
              </Box>
          </AspectRatio>
        </Flex>
      </Box>
     <Box  py={[20, 20, "150px"]} as='section'>
        <Heading mb={4} as='h2' fontSize="hb3" fontWeight="700" textAlign="center"  >
              {intl.formatMessage(ECOMMERCE_MESSAGES.shopbycategories)}
          </Heading>
      <SimpleGrid my={10} columns={[2,3]}  spacing={[1,3,8]} maxW='container.xl' mx='auto'>
        {
          data.collections.nodes.map((item,index)=>(
            <CollectionBox  collection={item}/>
          ))
        }
        </SimpleGrid>
     </Box>
     <Box mb={[20, 20, "150px"]} py={[20, 20, "150px"]} bg='outline.light' as='section'>
      <Heading mb={4} as='h2' fontSize="hb3" fontWeight="700" textAlign="center"  >
        {intl.formatMessage(ECOMMERCE_MESSAGES.newestarrivals)}
      </Heading>
      <SimpleGrid px={[2,3,5]} my="120px" columns={[2,2,3]}  spacing={[3,5,8]} maxW='container.xl' mx='auto'>
        {
          data.products.nodes.map((item,index)=>(
            <ProductItem product={item}/>
          ))
        }
        </SimpleGrid>
     </Box>

    
        <HowtoShopCheaperwithBriddgy/>
        <FAQ/>
        <Footer/>
      </>



    )
}

export const query = graphql`
  query {
 
    collections: allShopifyCollection(filter: {productsCount: {gt: 1},title: {nin: ["Computers","Electronics"]}}) {
      nodes {
        descriptionHtml
        image {
          altText
          gatsbyImageData
        }
        title
        slug
      }
    }
      products: allShopifyProduct(limit: 8, sort: {fields: createdAt, order: DESC}) {
        nodes {
          featuredImage {
            altText
            gatsbyImageData
          }
          images {
            gatsbyImageData
            altText
          }
          mediaCount
          title
          slug
          productType
          description
          priceRangeV2 {
            minVariantPrice {
              amount
            }
          }
          options {
            name
            values
          }
        }
      }
        image: file(relativePath: { eq: "mac-products.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
    }

  #   products:allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "product"}}}) {
  #       group(field: frontmatter___store, limit: 3) {
  #         nodes {
  #           frontmatter {
  #             image
  #             price
  #             store
  #             title
  #             url
  #             slug
  #           }
  #         }
  #       }
  #     }
  #   featured: allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "product"}}}, limit: 1) {
  #       nodes {
  #       frontmatter {
  #           categories
  #           title
  #           price
  #           image
  #           url
  #           description
  #           featured
  #           store
  #           slug
  #           config {
  #           lang
  #           code
  #           }
  #       }
  #       }
  # }
  #   brands:allMarkdownRemark(filter: {frontmatter: {templateKey: {eq: "shop"}}}) {
  #       nodes {
  #         frontmatter {
  #           title
  #           url
  #           logo
  #           slug
  #           content
  #         }
  #         html
  #       }
  #     }
  }
`


export default BriddgyShopPage